import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  token_type: null,
  expires_in: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.token_type = action.payload.token_type ?? "Bearer";
      state.expires_in = action.payload.expires_in ?? null;
      state.isAuthenticated = Boolean(action.payload.token && action.payload.user);
    },
    updateProfile(state, action) {
      if (!state.user) return;
      state.user = { ...state.user, ...action.payload };
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.token_type = null;
      state.expires_in = null;
      state.isAuthenticated = false;
    },
  },
});

export const { loginSuccess, updateProfile, logout } = authSlice.actions;
export default authSlice.reducer;
